module.exports = __webpack_public_path__ + "img/hcpasuransilainnya.5f86eb1b.svg";